module.exports = __webpack_public_path__ + "img/107.6818869c.jpg";